/* Homepage: transparent header floating over the hero, becomes solid on scroll.
   This script is only loaded by the LCC Hero section, so `lcc-home` is only
   ever added on the homepage. */
(function () {
  var root = document.body;
  root.classList.add('lcc-home');

  var solidAfter = 90;
  var ticking = false;

  function update() {
    if (window.scrollY > solidAfter) {
      root.classList.add('lcc-scrolled');
    } else {
      root.classList.remove('lcc-scrolled');
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });

  // Clean up if the section is removed in the theme editor.
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.lcc-hero')) {
      root.classList.remove('lcc-home', 'lcc-scrolled');
      window.removeEventListener('scroll', onScroll);
    }
  });
})();
